import React, { useContext, useEffect, useState } from "react";

import { css } from "@emotion/react";
import { DiscountQuantityButtonType } from "@intelligems/ig-types/src/dtos/deprecated/discounts";

import { DiscountQuantityContext } from "../../context";

import { ButtonPicker } from "./ButtonPicker";

interface WidgetButtonProps {
  button: DiscountQuantityButtonType;
  index: number;
}

export const ButtonRoot = ({ button, index }: WidgetButtonProps) => {
  const { theme, windowState, handleButtonClick } = useContext(
    DiscountQuantityContext
  );

  const buttonClass = css`
    display: flex;
    flex-direction: column;
    height: 80px;
    width: 137px;
    align-items: center;
    border-radius: ${theme.button.borderRadius};
    border: solid ${theme.button.borderThickness} ${theme.colors.border};
    justify-content: space-between;

    @media only screen and (max-width: 600px) {
      width: 105px;
      height: ${theme.button.height};
      font-size: 12px;
      line-height: 12px;
    }
    @media only screen and (min-width: 601px) {
      width: 135px;
      height: ${theme.button.height};
      font-size: 14px;
      line-height: 14px;
    }
  `;

  const [isHover, setIsHover] = useState<boolean>(false);
  const hoverSelect = isHover || windowState.selectedButtonIndex === index;

  const handleClick = (index: number, quantity: number) => {
    void handleButtonClick(index, quantity);
  };

  const handleMouseOver = () => {
    setIsHover(true);
  };
  const handleMouseOut = () => {
    setIsHover(false);
  };

  return (
    <div
      className={"ig-volume-widget-button"}
      css={
        hoverSelect
          ? css`
              ${buttonClass};
              border-color: ${theme.colors.secondary};
              cursor: pointer;
            `
          : buttonClass
      }
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      data-quantity={button.quantity}
      onClick={() => handleClick(index, button.quantity)}
    >
      <ButtonPicker
        button={button}
        unitDiscount={windowState.buttonState[index]?.unitDiscount || 0}
        mode={hoverSelect ? "hover" : "extra"}
        discountedUnitPrice={
          windowState.buttonState[index]?.discountedUnitPrice || ""
        }
      />
    </div>
  );
};
